import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import HowTo from "../pages/how-to/page";
import PrivacyPolicy from "../pages/privacy-policy/page";
import Terms from "../pages/terms/page";
import CommercialLaw from "../pages/commercial-law/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/how-to",
    element: <HowTo />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/commercial-law",
    element: <CommercialLaw />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;